import { render } from "./pointsComponent.vue?vue&type=template&id=b7713dec&scoped=true"
import script from "./pointsComponent.vue?vue&type=script&lang=js"
export * from "./pointsComponent.vue?vue&type=script&lang=js"

import "./pointsComponent.vue?vue&type=style&index=0&id=b7713dec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7713dec"]])

export default __exports__